// extracted by mini-css-extract-plugin
export default {"spinnerSection":"loading_spinnerSection__uc8Fb"};